import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { addMessage } from '../../app/snackbar/SnackbarActions';
import routes from '../../routes/routes.constants';
// eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent}
import { mixpanelEvents, trackEvent } from '../../utils/mixpanel';

import { computeOrganizationIdentifier } from './annotation-utils/annotation-utils';
import { Annotator } from './Annotator';
import AnnotatorConstants from './annotator.constants';
import * as AnnotatorActions from './AnnotatorActions';
// We only want to capture large changes in values and ignore subtle changes in
// both the x and y directions
const MOUSE_EVENT_THRESHOLD = 20;
const INCREASE = 'increase';
const DECREASE = 'decrease';

function mapDispatchToProps(dispatch: any, props: any) {
  const { history } = props;

  return {
    ...bindActionCreators(AnnotatorActions, dispatch),
    addMessage: bindActionCreators(addMessage, dispatch),
    getUniquePatientCount: () => '',
    switchPatient: (patientId: any) => {
      const search = props.location.search;
      history.push(`${routes.ANNOTATOR}/${patientId}${search}`);
    },
    trackValidationChange: (
      user: any,
      patientId: any,
      image: any,
      finding: any,
      newValidationValue: any,
      newValidationReasons: any,
    ) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- 'organizationIdentifier' is assigned a value but never used.
      const organizationIdentifier = computeOrganizationIdentifier(patientId);
      const event = {
        objectId: image.objectId,
        state: image.analysisState,
        fileName: image.fileName,
      };

      if (newValidationValue) {
        const eventName = !finding.validation
          ? mixpanelEvents.createAiValidation
          : mixpanelEvents.updateAiValidation;
        const validationChangeElements = finding.validation
          ? { prevValidation: finding.validation }
          : {};
        // eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent}
        trackEvent(eventName, user, {
          ...event,
          validation: newValidationValue,
          ...validationChangeElements,
        });
      }

      if (newValidationReasons) {
        let eventName = '';
        const isCreatingReasons =
          !Array.isArray(finding.validationReasons) ||
          !finding.validationReasons.length;
        if (finding.validation === AnnotatorConstants.VALIDATIONS.AGREE) {
          eventName = isCreatingReasons
            ? mixpanelEvents.createAgreementReason
            : mixpanelEvents.updateAgreementReason;
        } else if (
          finding.validation === AnnotatorConstants.VALIDATIONS.DISAGREE
        ) {
          eventName = isCreatingReasons
            ? mixpanelEvents.createDisagreeReason
            : mixpanelEvents.updateDisagreeReason;
        }
        // eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent}
        trackEvent(eventName, user, {
          ...event,
          validationReasons: newValidationReasons,
        });
      }
    },
    trackCornerstoneMouseEvent: (
      image = {},
      prevMouseEvent = {},
      currentMouseEvent = {},
      user: any,
    ) => {
      // @ts-expect-error TS(2339): Property 'objectId' does not exist on type '{}'.
      const { objectId } = image;
      // @ts-expect-error TS(2339): Property 'clientX' does not exist on type '{}'.
      const { clientX: prevClientX, clientY: prevClientY } = prevMouseEvent;
      // @ts-expect-error TS(2339): Property 'clientX' does not exist on type '{}'.
      const { clientX: currentClientX, clientY: currentClientY } =
        currentMouseEvent;

      const hasContrastChanged =
        Math.abs(currentClientX - prevClientX) > MOUSE_EVENT_THRESHOLD;
      const hasBrightnessChanged =
        Math.abs(currentClientY - prevClientY) > MOUSE_EVENT_THRESHOLD;
      if (hasContrastChanged) {
        const variation =
          currentClientX - prevClientX < 0 ? INCREASE : DECREASE;
        /* eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent} */
        trackEvent(mixpanelEvents.imageContrastChanged, user, {
          objectId,
          variation,
        });
      }

      if (hasBrightnessChanged) {
        const variation =
          currentClientY - prevClientY < 0 ? INCREASE : DECREASE;
        /* eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent} */
        trackEvent(mixpanelEvents.imageBrightnessChanged, user, {
          objectId,
          variation,
        });
      }
    },
    trackConfidenceChange: (
      image: any,
      confidenceThreshold: any,
      user: any,
    ) => {
      /* eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent} */
      trackEvent(mixpanelEvents.confidenceThresholdChanged, user, {
        confidenceThreshold,
        image,
      });
    },
    trackImageInversion: (image: any, isInverted: any, user: any) => {
      // eslint-disable-next-line import/no-deprecated -- Deprecated: prefer {@link useTrackEvent}
      trackEvent(mixpanelEvents.imageInversionChange, user, {
        objectId: image?.objectId,
        isInverted,
      });
    },
  };
}

function mapStateToProps(state: any, ownProps: any) {
  const { match } = ownProps;
  const { login, annotator, uploader } = state;
  const selectedPatientId = match.params.id;

  return {
    confidenceThresholds: annotator.confidenceThresholds,
    institution: login.institution,
    uploaderStatus: uploader.status,
    user: login.user,
    patients: state.annotator.patients,
    practice: login.practice,
    imageAnalyses: annotator.imageAnalyses,
    selectedPatientId,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Annotator);
